import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { CFormText, CInput } from "@coreui/react";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { setSelected } from "../redux/rolesSagas";

export const Filters = () => {
  const dispatch = useDispatch();

  const {
    selected: { organization, name, identifier },
    currentUser: { organizations }
  } = useSelector((state) => state.roles);

  const onOrganizationChange = (selected) => {
    dispatch(setSelected({ organization: selected }));
  };

  const onInputChange = (title, key) => {
    dispatch(setSelected({ [key]: title }));
  };

  return (
    <>
      <div className="roles__section light">
        <div className="roles__section__el">
          <p>Organizations</p>
          <Dropdown
            height={275}
            haveOnSelectChange
            placeholder="Select Organization"
            options={organizations}
            selectedFilters={organization}
            enableDefaultSelected
            numberDisplayed={3}
            maxSelect={1}
            enableMax
            onSelectChange={(data) => onOrganizationChange(data)}
          />
          <CFormText className="help-block">
            {!organization ? "Please choose at least 1 organization" : ""}
          </CFormText>
        </div>

        <div className="roles__section__el">
          <p>Name</p>
          <CInput
            onChange={(e) => onInputChange(e.target.value, "name")}
            className="text-input"
            type="text"
            placeholder="Add Name"
            value={name}
          />
          <CFormText className="help-block">
            {name && name.trim() ? "" : "* Please add name"}
          </CFormText>
        </div>

        <div className="roles__section__el">
          <p>Identifier</p>
          <CInput
            onChange={(e) => onInputChange(e.target.value, "identifier")}
            className="text-input"
            type="text"
            placeholder="Add Identifier"
            value={identifier}
          />
          <CFormText className="help-block">
            {identifier && identifier.trim() ? "" : "* Please add identifier"}
          </CFormText>
        </div>
      </div>
    </>
  );
};
